var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    width: "40px",
    height: "20px",
    viewBox: "22 17 25 30",
    alt: "Video",
    enableBackground: "new 0 0 64 64",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.387,28.908L28.212,18.92c-2.619-1.723-4.762-0.567-4.762,2.568v21.02c0,3.135,2.146,4.294,4.77,2.577l15.162-9.921 C46.004,33.445,46.007,30.631,43.387,28.908z",
    stroke: "#777",
    strokeMiterlimit: 10,
    strokeWidth: "1.81px"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/Video.8d14e5e7.svg";
export { ForwardRef as ReactComponent };